import React from "react";
import i18next from "i18next";

const ThereIsMore = () => (
    <div className="there-is-more">
        {i18next.t("productDetails.thereIsMore")}
    </div>
);

export default ThereIsMore;
